import { Paper, Typography, Stack, Divider } from "@mui/material";

const KpiCard = ({ title, showVsAop = false }) => {
	return (
		<Paper
			variant="outlined"
			sx={{
				p: 2,
				width: "80%",
				height: 145,
				borderRadius: 2,
			}}>
			<Stack spacing={0.7}>
				<Typography variant="subtitle2" color="text.secondary">
					<Divider>{title}</Divider>
				</Typography>

				<Typography variant="body2">Net Sale:</Typography>
				<Typography variant="body2">Absorbed Discount:</Typography>
				<Typography variant="body2">Catalog Discount(%):</Typography>
				<Typography variant="body2">Sale Through:</Typography>

				{showVsAop && <Typography variant="body2">Vs AOP:</Typography>}
			</Stack>
		</Paper>
	);
};

export default KpiCard;
